import { useCallback, useEffect, useState } from 'react';
import './App.css';
import DataTable from './components/DataTable';
import RegionPopup from './components/RegionPopup';
import StreamGraph from './components/StreamGraph';
import TimelineGauge from './components/TimelineGauge';
import WorldMap from './components/WorldMap';
import ZoneDescription from './components/ZoneDescription';

function App() {
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [activeIpType, setActiveIpType] = useState('ipv4');
  const [activeTab, setActiveTab] = useState('graph');
  const [geoipData, setGeoipData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  // Load data.json using fetch
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const response = await fetch('/data.json');
        if (!response.ok) {
          throw new Error(`Failed to load data: ${response.status}`);
        }
        const data = await response.json();
        setGeoipData(data);
        setError(null);
      } catch (err) {
        console.error('Error loading data.json:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handleRegionSelect = (region) => {
    setSelectedRegion(region);
  };

  const handleClosePopup = () => {
    setSelectedRegion(null);
  };

  const handleBackToMap = () => {
    setSelectedRegion(null);
    setActiveIpType('ipv4'); // Reset to IPv4 when returning to map
  };

  const handleDateChange = useCallback((date) => {
    setSelectedDate(date);
  }, []);



  // Show loading state
  if (loading) {
    return (
      <div className="App">
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          fontSize: '1.2rem',
          color: '#666'
        }}>
          Loading  IP geolocation data...
        </div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="App">
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          fontSize: '1.2rem',
          color: '#d32f2f',
          textAlign: 'center'
        }}>
          <div>
            <h2>Error loading data</h2>
            <p>{error}</p>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        </div>
      </div>
    );
  }

  // Show app when data is loaded
  if (!geoipData) {
    return (
      <div className="App">
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          fontSize: '1.2rem',
          color: '#666'
        }}>
          No data available
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="main-container">
        {/* Left column - Map or Charts (7/12) */}
        <div className="left-column">
          {/* Show the map when no region is selected */}
          {!selectedRegion && (
            <WorldMap
              geoipData={geoipData}
              onRegionSelect={handleRegionSelect}
            />
          )}

          {/* Show the charts when a region is selected */}
          {selectedRegion && (
            <RegionPopup
              region={selectedRegion}
              data={geoipData}
              onClose={handleClosePopup}
              onBackToMap={handleBackToMap}
              onIpTypeChange={setActiveIpType}
              currentIpType={activeIpType}
              globalDate={selectedDate}
            />
          )}
        </div>

        {/* Right column - Tabs (5/12) */}
        <div className="right-column">
          {selectedRegion ? (
            <div className="tabs-container">
              <div className="tabs-header">
                <button
                  className={`tab-button ${activeTab === 'graph' ? 'active' : ''}`}
                  onClick={() => setActiveTab('graph')}
                >
                  Graph
                </button>
                <button
                  className={`tab-button ${activeTab === 'description' ? 'active' : ''}`}
                  onClick={() => setActiveTab('description')}
                >
                  Description
                </button>

                <button
                  className={`tab-button ${activeTab === 'table' ? 'active' : ''}`}
                  onClick={() => setActiveTab('table')}
                >
                  Table
                </button>
              </div>

              <div className="tab-content">
                {/* Description Tab */}
                {activeTab === 'description' && (
                  <div>
                    <h3>Region Information</h3>
                    <div className="description-content">
                      <ZoneDescription region={selectedRegion} />
                    </div>
                  </div>
                )}

                {/* Graph Tab */}
                {activeTab === 'graph' && (
                  <div>

                    {/* Timeline Gauge */}
                    <TimelineGauge
                      region={selectedRegion}
                      data={geoipData}
                      ipType={activeIpType}
                      onDateChange={handleDateChange}
                    />

                    {/* Stream Graph */}
                    {selectedDate && (
                      <>

                        <div >
                          <StreamGraph
                            region={selectedRegion}
                            data={geoipData}
                            ipType={activeIpType}
                            globalDate={selectedDate}
                            selectedTimestamp={Math.floor(selectedDate.getTime() / 1000)}
                            showTTonMouse
                          />
                        </div>

                        {/* 
                        <div style={{ marginTop: '20px' }}>
                          <CountryPieChart
                            region={selectedRegion}
                            data={geoipData}
                            ipType={activeIpType}
                            selectedTimestamp={Math.floor(selectedDate.getTime() / 1000)}
                          />
                        </div>
                        */}
                      </>
                    )}




                  </div>
                )}

                {/* Table Tab */}
                {activeTab === 'table' && (
                  <div>
                    <h3>Data Summary</h3>
                    <DataTable
                      region={selectedRegion}
                      data={geoipData}
                      ipType={activeIpType}
                    />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <>

            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
